module.exports = __webpack_public_path__ + "img/icon-question.b068537d.svg";